import { render, staticRenderFns } from "./media_opt.vue?vue&type=template&id=090a4206&scoped=true&"
import script from "./media_opt.vue?vue&type=script&lang=js&"
export * from "./media_opt.vue?vue&type=script&lang=js&"
import style0 from "./media_opt.vue?vue&type=style&index=0&id=090a4206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a4206",
  null
  
)

export default component.exports